export enum MobergBoxShadow {
    LOW = "1px 3px 4px 0px rgba(0,0,0,0.15)",
    LOW_DARK = "1px 3px 4px 0px rgba(0,0,0,0.3)",
    REGULAR = "rgba(0, 0, 0, 0.24) 0px 3px 8px",
    MEDIUM_DARK = "0 10px 15px -3px rgba(0, 0, 0, 0.3), 0 4px 6px -2px rgba(0, 0, 0, 0.15)"
}